import HeaderPage from "../../components/HeaderPage/HeaderPage.vue";
import HomeBody from "../../components/HomeBody/HomeBody.vue";

export default {
    name: 'HomeScreen',
    components: {
		HeaderPage,
        HomeBody
	},
    data() {
        return {
        };
    },
    methods: {

    },
};
